import * as React from 'react';

export const useChangeValues = <T>() => {
  const [values, setValues] = React.useState<T>({} as T);

  const setValue = React.useCallback((name: keyof T, value: string) => {
    setValues(prevCalculatorValues => ({
      ...prevCalculatorValues,
      [name]: value,
    }));
  }, []);

  return { values, setValue };
};
